import React from 'react';
import { useInterpret } from '@xstate/react';
import { MetricMachineContext, createMemoizedMetricMachine } from './MetricFormContext';
import { metricMachine } from '../StateMachine/MetricFormMachine';
export var MetricContextProvider = function (props) {
    var children = props.children;
    var metricService = useInterpret(metricMachine);
    return (React.createElement(MetricMachineContext.Provider, { value: createMemoizedMetricMachine(metricService) }, children));
};
